import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

interface DialogData {
  name: string;
}

@Component({
  selector: 'app-new-attachments',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule],
  templateUrl: './new-attachments.component.html',
  styleUrls: ['./new-attachments.component.scss'],
})
export class NewAttachmentComponent {
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<NewAttachmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  public dataForm = this.fb.group({
    name: new FormControl(this.data.name, [Validators.required]),
  });

  public sendNewAttachment() {
    this.dialogRef.close(this.dataForm.value.name);
  }
}
